module.exports = __webpack_public_path__ + "static/media/ServiceDefault.98ebfb5f.jpg";